import React from 'react'

const Expand = ({ className = '', width = '1em', height = '1em', expanded = true, ...props }) => (
  <svg
    className={`ac-icon ac-icon__expand ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0 M12,2c5.5,0,10,4.5,10,10s-4.5,10-10,10S2,17.5,2,12S6.5,2,12,2' />
    <path d='M16.5,13c0.3,0,0.5-0.2,0.5-0.5v-1c0-0.3-0.2-0.5-0.5-0.5h-5.2l0,0H7.5C7.2,11,7,11.2,7,11.5v1C7,12.8,7.2,13,7.5,13' />
    {expanded && (
      <path d='M13,7.5C13,7.2,12.8,7,12.5,7h-1C11.2,7,11,7.2,11,7.5v5.2l0,0v3.8c0,0.3,0.2,0.5,0.5,0.5h1c0.3,0,0.5-0.2,0.5-0.5' />
    )}
  </svg>
)

export default Expand
